/* =========================================================================
   viaim Rise — DTC landing page behaviour
   File: assets/rise-lp.js  (loaded with defer by every rise-lp-* section)
   - CTA links: UTM / click-id pass-through to Indiegogo + click tracking
   - Engagement events (GA4 gtag + Shopify customer events for pixels)
   - Hero coded illustration, scene explorer, lazy demo video, sticky CTA
   Safe to load more than once (guarded). No dependencies.
   ========================================================================= */
(function () {
  'use strict';
  if (window.RiseLP && window.RiseLP.loaded) return;

  var doc = document;
  var win = window;
  var DEFAULT_URL = 'https://www.indiegogo.com/projects/viaim/viaim-rise?refcode=rslkAV-rQE2PNlFVk5Hf8A';
  var reduceMotion = !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var designMode = !!(win.Shopify && win.Shopify.designMode);
  var qs;
  try { qs = new URLSearchParams(win.location.search); } catch (e) { qs = { get: function () { return null; } }; }

  /* ---------------------------------------------------------------- config */
  var cfg = (function () {
    var c = {};
    var el = doc.getElementById('RlpConfig');
    if (el) { try { c = JSON.parse(el.textContent || '{}'); } catch (e) { c = {}; } }
    return {
      url: c.url || DEFAULT_URL,
      newTab: c.newTab !== false,
      utm: c.utm !== false,
      utmSource: c.utmSource || 'store.viaim.ai',
      utmMedium: c.utmMedium || 'lp_cta',
      campaignFallback: c.campaignFallback || 'rise_lp',
      passIds: c.passIds !== false,
      variant: c.variant || 'rise-lp',
      engaged: Math.max(5, Number(c.engaged) || 15),
      lift: c.lift !== false
    };
  })();

  var sceneParam = String(qs.get('scene') || qs.get('v') || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40);
  var currentScene = '';
  var visibleMs = 0;

  /* -------------------------------------------------------------- helpers */
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function throttle(fn, wait) {
    var t = 0, timer = null;
    return function () {
      var now = Date.now();
      if (now - t >= wait) { t = now; fn(); }
      else if (!timer) { timer = setTimeout(function () { timer = null; t = Date.now(); fn(); }, wait - (now - t)); }
    };
  }
  function hasGTM() {
    var g = win.google_tag_manager;
    if (!g) return false;
    for (var k in g) { if (k.indexOf('GTM-') === 0) return true; }
    return false;
  }

  /* ------------------------------------------------------------- tracking */
  function track(name, data) {
    var payload = {};
    for (var k in (data || {})) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; }
    payload.lp_variant = cfg.variant;
    payload.lp_entry = sceneParam || 'default';
    // GA4 (gtag is loaded globally by theme.liquid on store.viaim.ai)
    try { if (typeof win.gtag === 'function') win.gtag('event', 'lp_' + name, payload); } catch (e) {}
    // Google Tag Manager, only if a GTM container is present
    try { if (hasGTM()) { var o = { event: 'rise_lp_' + name }; for (var j in payload) o[j] = payload[j]; (win.dataLayer = win.dataLayer || []).push(o); } } catch (e) {}
    // Shopify customer events -> custom pixels (e.g. Meta "ClickToIGG")
    try {
      if (win.Shopify && win.Shopify.analytics && typeof win.Shopify.analytics.publish === 'function') {
        var p = win.Shopify.analytics.publish('viaim_lp:' + name, payload);
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------- CTA links */
  function buildUrl(base) {
    var u;
    try { u = new URL(base || cfg.url, win.location.href); } catch (e) { return base || cfg.url; }
    if (cfg.utm) {
      u.searchParams.set('utm_source', cfg.utmSource);
      u.searchParams.set('utm_medium', cfg.utmMedium);
      u.searchParams.set('utm_campaign', qs.get('utm_campaign') || cfg.campaignFallback);
      var content = qs.get('utm_content'); if (content) u.searchParams.set('utm_content', content);
      var term = qs.get('utm_term'); if (term) u.searchParams.set('utm_term', term);
    }
    if (cfg.passIds) {
      ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid'].forEach(function (k) {
        var v = qs.get(k); if (v) u.searchParams.set(k, v);
      });
    }
    return u.toString();
  }
  function decorateLinks(root) {
    each((root || doc).querySelectorAll('a[data-rlp-cta]'), function (a) {
      a.href = buildUrl(a.getAttribute('data-rlp-href') || cfg.url);
      if (cfg.newTab) { a.target = '_blank'; a.rel = 'noopener'; }
      else { a.removeAttribute('target'); }
    });
  }
  doc.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-rlp-cta]') : null;
    if (!a) return;
    a.href = buildUrl(a.getAttribute('data-rlp-href') || cfg.url);
    track('cta_click', {
      cta_position: a.getAttribute('data-rlp-cta') || 'unknown',
      cta_label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      scene: currentScene,
      seconds_on_page: Math.round(visibleMs / 1000)
    });
  }, true);

  /* ------------------------------------------------- engagement + scroll */
  (function () {
    var last = Date.now(), sent = false;
    setInterval(function () {
      var now = Date.now();
      if (doc.visibilityState === 'visible') visibleMs += now - last;
      last = now;
      if (!sent && visibleMs >= cfg.engaged * 1000) { sent = true; track('engaged', { seconds: cfg.engaged }); }
    }, 1000);
    var marks = [25, 50, 75, 90], done = {};
    var onScroll = throttle(function () {
      var h = doc.documentElement;
      var max = h.scrollHeight - win.innerHeight;
      if (max <= 0) return;
      var pct = (win.pageYOffset || h.scrollTop) / max * 100;
      marks.forEach(function (m) { if (pct >= m && !done[m]) { done[m] = 1; track('scroll', { percent: m }); } });
    }, 500);
    win.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* --------------------------------------------------- header state */
  function initHeader(root) {
    var top = root.querySelector('[data-rlp-top]');
    if (!top || top.rlpInit) return;
    top.rlpInit = true;
    var upd = throttle(function () { top.classList.toggle('is-scrolled', (win.pageYOffset || 0) > 8); }, 120);
    win.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ------------------------------------------- sticky CTA (mobile) */
  var lifted = [];
  function liftWidgets(on, h) {
    if (!on) { lifted.forEach(function (el) { el.style.translate = ''; }); lifted = []; return; }
    var vw = win.innerWidth, vh = win.innerHeight;
    each(doc.querySelectorAll('body > *, body > * > *'), function (el) {
      if (!el.getBoundingClientRect || (el.closest && el.closest('.rlp'))) return;
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'MAIN' || tag === 'FOOTER') return;
      var cs = win.getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height || r.width > vw * 0.6 || vh - r.bottom > 140) return;
      if (lifted.indexOf(el) === -1) lifted.push(el);
      el.style.translate = '0 -' + Math.round(h + 6) + 'px';
    });
  }
  function initSticky(root) {
    var bar = root.querySelector('[data-rlp-sticky]');
    if (!bar || bar.rlpInit || designMode) return;
    bar.rlpInit = true;
    var heroCta = root.querySelector('[data-rlp-hero-cta]');
    var heroVisible = true, finalVisible = false, isOn = false, mo = null;
    var mobile = win.matchMedia ? win.matchMedia('(max-width: 989px)') : { matches: true };
    function update() {
      var on = !heroVisible && !finalVisible && mobile.matches;
      if (on === isOn) return;
      isOn = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !on;
      if (cfg.lift) {
        liftWidgets(on, bar.offsetHeight);
        if (on && !mo && 'MutationObserver' in win) {
          mo = new MutationObserver(throttle(function () { if (isOn) liftWidgets(true, bar.offsetHeight); }, 800));
          mo.observe(doc.body, { childList: true });
        }
      }
    }
    bar.setAttribute('aria-hidden', 'true');
    if ('inert' in bar) bar.inert = true;
    if (!('IntersectionObserver' in win) || !heroCta) { heroVisible = false; update(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { heroVisible = e.isIntersecting || e.boundingClientRect.top > 0; });
      update();
    }, { threshold: 0 }).observe(heroCta);
    var finals = doc.querySelectorAll('[data-rlp-final]');
    if (finals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; });
        update();
      }, { threshold: 0.12 });
      each(finals, function (f) { io.observe(f); });
    }
    if (mobile.addEventListener) mobile.addEventListener('change', update);
  }

  /* ------------------------------------------- hero coded illustration */
  function initHeroAnim(root) {
    var stage = root.querySelector('[data-rlp-hero-anim]');
    if (!stage || stage.rlpInit) return;
    stage.rlpInit = true;
    var timerEl = stage.querySelector('[data-rlp-timer]');
    var secs = parseInt(stage.getAttribute('data-start') || '42', 10) || 0;
    function fmt(s) { var m = Math.floor(s / 60) % 60, x = s % 60; return (m < 10 ? '0' : '') + m + ':' + (x < 10 ? '0' : '') + x; }
    if (timerEl) timerEl.textContent = fmt(secs);
    if (reduceMotion) { stage.setAttribute('data-state', 'ask'); return; }
    var steps = [
      { s: 'rec', t: 900 }, { s: 'quote', t: 1900 }, { s: 'draft', t: 1200 }, { s: 'ask', t: 1700 },
      { press: true, t: 420 }, { s: 'sent', t: 2700 }, { s: 'rec', t: 600 }
    ];
    // Start from the server-rendered "ask" state so nothing flashes when JS boots.
    var i = 3, to = null, running = false, visible = false, clock = null;
    function apply(step) {
      if (step.press) { stage.setAttribute('data-press', '1'); return; }
      stage.removeAttribute('data-press');
      stage.setAttribute('data-state', step.s);
    }
    function tick() {
      if (!running) return;
      var step = steps[i];
      apply(step);
      i = (i + 1) % steps.length;
      to = setTimeout(tick, step.t);
    }
    function start() {
      if (running) return;
      running = true; tick();
      clock = setInterval(function () { secs = (secs + 1) % 3600; if (timerEl) timerEl.textContent = fmt(secs); }, 1000);
    }
    function stop() { running = false; clearTimeout(to); clearInterval(clock); }
    function sync() { if (visible && doc.visibilityState === 'visible') start(); else stop(); }
    if (!stage.getAttribute('data-state')) stage.setAttribute('data-state', 'ask');
    if ('IntersectionObserver' in win) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; }); sync(); }, { threshold: 0.2 }).observe(stage);
    } else { visible = true; sync(); }
    doc.addEventListener('visibilitychange', sync);
  }

  /* ------------------------------------------------------ demo video */
  function initVideos(root) {
    each(root.querySelectorAll('[data-rlp-video]'), function (box) {
      if (box.rlpInit) return;
      box.rlpInit = true;
      var v = box.querySelector('video');
      if (!v) return;
      var name = box.getAttribute('data-rlp-video') || 'demo';
      var src = { s480: v.getAttribute('data-src-480'), s720: v.getAttribute('data-src-720'), s1080: v.getAttribute('data-src-1080'), any: v.getAttribute('data-src') };
      var loaded = false, userPaused = false, started = false, marks = {};
      function pick() {
        var conn = navigator.connection || {};
        var slow = !!conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
        var px = box.clientWidth * Math.min(win.devicePixelRatio || 1, 2);
        if (slow) return src.s480 || src.s720 || src.any || src.s1080;
        if (px > 1350) return src.s1080 || src.s720 || src.any || src.s480;
        return src.s720 || src.s1080 || src.any || src.s480;
      }
      function load() { if (loaded) return; var s = pick(); if (!s) return; v.src = s; loaded = true; }
      function play() {
        load();
        if (!loaded) return;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () { box.classList.add('is-paused'); });
      }
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.addEventListener('playing', function () {
        box.classList.add('is-playing'); box.classList.remove('is-paused');
        if (!started) { started = true; track('video', { action: 'start', video: name }); }
      });
      v.addEventListener('pause', function () { box.classList.add('is-paused'); });
      v.addEventListener('timeupdate', function () {
        if (!v.duration) return;
        var pct = v.currentTime / v.duration * 100;
        [25, 50, 75, 95].forEach(function (m) { if (pct >= m && !marks[m]) { marks[m] = 1; track('video', { action: 'progress', percent: m, video: name }); } });
      });
      var btn = box.querySelector('[data-rlp-video-toggle]');
      if (btn) btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; play(); btn.setAttribute('aria-label', btn.getAttribute('data-label-pause') || 'Pause'); }
        else { userPaused = true; v.pause(); btn.setAttribute('aria-label', btn.getAttribute('data-label-play') || 'Play'); }
      });
      box.rlpPlayFromStart = function () { userPaused = false; load(); try { v.currentTime = 0; } catch (e) {} play(); };
      if ('IntersectionObserver' in win) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) load(); }); }, { rootMargin: '400px 0px' }).observe(box);
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { if (!userPaused) play(); } else if (!v.paused) { v.pause(); } });
        }, { threshold: 0.35 }).observe(box);
      } else { load(); }
    });
    each(root.querySelectorAll('[data-rlp-play-demo]'), function (a) {
      if (a.rlpInit) return;
      a.rlpInit = true;
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
        var target = id ? doc.getElementById(id) : null;
        if (!target) return;
        e.preventDefault();
        track('demo_click', { from: a.getAttribute('data-rlp-play-demo') || 'hero' });
        var box = target.querySelector('[data-rlp-video]') || target;
        var y = box.getBoundingClientRect().top + (win.pageYOffset || 0) - Math.max(16, (win.innerHeight - box.offsetHeight) / 2);
        try { win.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (err) { win.scrollTo(0, y); }
        if (box.rlpPlayFromStart) box.rlpPlayFromStart();
      });
    });
  }

  /* -------------------------------------------------- scene explorer */
  function stagger(panel) {
    if (panel.rlpStaggered) return;
    panel.rlpStaggered = true;
    var d = 0.1;
    each(panel.querySelectorAll('.rlp-steps > *'), function (el) {
      el.style.setProperty('--d', d.toFixed(2) + 's');
      if (el.classList.contains('rlp-step--listen')) {
        var lines = el.querySelectorAll('.rlp-line');
        each(lines, function (ln, k) {
          var ld = d + 0.25 + k * 0.4;
          ln.style.setProperty('--d', ld.toFixed(2) + 's');
          each(ln.querySelectorAll('mark'), function (m) { m.style.setProperty('--md', (ld + 0.45).toFixed(2) + 's'); });
        });
        d += 0.45 + lines.length * 0.4;
      } else if (el.classList.contains('rlp-step--think')) {
        var rows = el.querySelectorAll('.rlp-row');
        each(rows, function (r, k) { r.style.setProperty('--d', (d + 0.2 + k * 0.22).toFixed(2) + 's'); });
        d += 0.45 + rows.length * 0.22;
      } else if (el.classList.contains('rlp-say')) {
        d += 0.6;
      } else {
        each(el.querySelectorAll('mark'), function (m) { m.style.setProperty('--md', (d + 0.55).toFixed(2) + 's'); });
        el.style.setProperty('--ad', (d + 1.1).toFixed(2) + 's');
        d += 0.6;
      }
    });
  }
  function initScenes(root) {
    each(root.querySelectorAll('[data-rlp-scenes]'), function (sec) {
      if (sec.rlpInit) return;
      sec.rlpInit = true;
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(sec.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      var dur = Math.max(6, parseInt(sec.getAttribute('data-duration') || '11', 10)) * 1000;
      var auto = sec.getAttribute('data-autoplay') === 'true' && !reduceMotion && !designMode && tabs.length > 1;
      var idx = 0, timer = null, inView = false, hover = false;
      sec.style.setProperty('--rlp-dur', dur / 1000 + 's');
      sec.classList.toggle('is-auto', auto);
      panels.forEach(stagger);
      function restartBar() {
        var bar = tabs[idx].querySelector('.rlp-tab__bar i');
        if (!bar) return;
        bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      }
      function schedule() {
        clearTimeout(timer);
        var paused = !inView || hover || doc.visibilityState !== 'visible';
        sec.classList.toggle('is-paused', paused);
        if (auto && !paused) timer = setTimeout(function () { show(idx + 1, false); }, dur);
      }
      function play(panel) {
        if (inView || reduceMotion || designMode) panel.classList.add('is-play');
      }
      function show(i, byUser) {
        idx = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, k) {
          var on = k === idx;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, k) { var on = k === idx; p.hidden = !on; if (!on) p.classList.remove('is-play'); });
        var p = panels[idx];
        p.classList.remove('is-play'); void p.offsetWidth; play(p);
        currentScene = p.getAttribute('data-scene') || String(idx + 1);
        restartBar();
        schedule();
        if (byUser) track('scene_select', { scene: currentScene, index: idx + 1 });
      }
      function stopAuto() { if (!auto) return; auto = false; sec.classList.remove('is-auto'); clearTimeout(timer); }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { stopAuto(); show(k, true); });
        t.addEventListener('keydown', function (e) {
          var key = e.key, n = null;
          if (key === 'ArrowRight' || key === 'ArrowDown') n = idx + 1;
          else if (key === 'ArrowLeft' || key === 'ArrowUp') n = idx - 1;
          else if (key === 'Home') n = 0;
          else if (key === 'End') n = tabs.length - 1;
          if (n === null) return;
          e.preventDefault(); stopAuto(); show(n, true); tabs[idx].focus();
        });
      });
      sec.addEventListener('mouseenter', function () { hover = true; schedule(); });
      sec.addEventListener('mouseleave', function () { hover = false; if (auto) { restartBar(); } schedule(); });
      sec.addEventListener('touchstart', function (e) { if (e.target.closest && e.target.closest('.rlp-panel')) stopAuto(); }, { passive: true });
      doc.addEventListener('visibilitychange', schedule);
      // entry from an ad: ?scene=calls preselects that scene
      var start = 0;
      if (sceneParam) panels.forEach(function (p, k) { if ((p.getAttribute('data-scene') || '').toLowerCase() === sceneParam) start = k; });
      if ('IntersectionObserver' in win) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var was = inView;
            inView = e.isIntersecting;
            if (inView && !was) { play(panels[idx]); if (auto) restartBar(); }
            schedule();
          });
        }, { threshold: 0.25 }).observe(sec);
      } else { inView = true; }
      show(start, false);
      sec.rlpShow = function (i) { stopAuto(); show(i, false); };
      sec.addEventListener('shopify:block:select', function (e) {
        var p = e.target && e.target.closest ? e.target.closest('[role="tabpanel"]') : null;
        var k = panels.indexOf(p);
        if (k > -1) sec.rlpShow(k);
      });
    });
  }

  /* ---------------------------------------------------- FAQ + reveal */
  function initFaq(root) {
    each(root.querySelectorAll('[data-rlp-faq] details'), function (d) {
      if (d.rlpInit) return;
      d.rlpInit = true;
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var q = d.querySelector('summary');
        track('faq_open', { question: q ? q.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) : '' });
      });
    });
  }
  var revealIO = null;
  function initReveal(root) {
    var els = root.querySelectorAll('[data-rlp-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || designMode || !('IntersectionObserver' in win)) { each(els, function (el) { el.classList.add('is-in'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    var vh = win.innerHeight || 800;
    each(els, function (el) {
      // already on screen at boot: show immediately (same frame, so no flash)
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); return; }
      revealIO.observe(el);
    });
  }

  /* ------------------------------------------------------------- init */
  function init(root) {
    root = root || doc;
    each(root.querySelectorAll ? root.querySelectorAll('.rlp') : [], function (el) { el.classList.add('rlp--anim'); });
    if (root.classList && root.classList.contains('rlp')) root.classList.add('rlp--anim');
    decorateLinks(root);
    initHeader(root);
    initSticky(root);
    initHeroAnim(root);
    initVideos(root);
    initScenes(root);
    initFaq(root);
    initReveal(root);
  }

  window.RiseLP = { loaded: true, init: init, track: track, buildUrl: buildUrl, config: cfg };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  // Theme editor: re-init a section after it is re-rendered
  doc.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();